// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectDetailPage_wrapper__zjI3f","preview":"ProjectDetailPage_preview__mmEDo","item-wrap":"ProjectDetailPage_item-wrap__F6YDh"};